if(typeof __WEBPACK_EXTERNAL_MODULE__51__ === 'undefined') { var e = new Error("Cannot find module '@jupyter-widgets/base'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = __WEBPACK_EXTERNAL_MODULE__51__;